import { z } from "zod";

export type CompanyMeta = z.infer<typeof companyMetaSchema>;

export const companyMetaSchema = z.object({
  general: z.object({
    companyName: z.string(),
    city: z.string(),
    street: z.string(),
    postalCode: z.string(),
    nip: z.string(),
    regon: z.string(),
    krs: z.string(),
    additionalInfo: z.string(),
  }),
  socials: z.object({
    linkedinUrl: z.string(),
    instagramUrl: z.string(),
    facebookUrl: z.string(),
  }),
});
